import { jsxs, jsx } from 'react/jsx-runtime';
import React__default, { Component } from 'react';
import cns from '../../node_modules/classnames/index.js';
import Tab from './Tab.js';
import { deprecatedUsage } from '../Utils/devUtils.js';

/**
I tabs sono normalmente posizionati al di sopra del contenuto, e le loro label danno sempre indicazione di cosa si trova al loro interno.

Inserirli sempre una riga orizzontale.

Evidenziare il tab  che mostra il contenuto.

Creare una gerarchia nei diversi tabs.

Il contenuto del tab deve essere posizionato al di sotto e vicino per creare una relazione fra i due.
 */
class Tabs extends Component {
    constructor(props) {
        super(props);
        this.caricaStorage = () => {
            if (window.sessionStorage) {
                const { store } = this.props;
                const dati = window.sessionStorage.getItem(store);
                if (!dati) {
                    return null;
                }
                return JSON.parse(dati);
            }
            return null;
        };
        this.salvaStorage = (dati) => {
            if (window.sessionStorage) {
                const { store } = this.props;
                window.sessionStorage.setItem(store, JSON.stringify(dati));
            }
        };
        this.aggiorna = () => {
            const { children } = this.props;
            const { index } = this.state;
            const tabs = React__default.Children.toArray(children).filter((child) => child).length;
            if ((index + 1) > tabs) {
                //  Se elimino tab elezionato scalo la selezione al precedente
                this.seleziona(index - 1);
            }
        };
        this.seleziona = (indice) => {
            const { index, onSelect, children } = this.props;
            if (index == null) {
                //  Se tab da selezionare è disabilitato scalo al tab precedente
                const element = React__default.Children.toArray(children)[indice];
                if (element.props.disabled) {
                    this.seleziona(indice - 1);
                }
                else {
                    this.setState({ index: indice });
                }
            }
            const { store } = this.props;
            if (store) {
                this.salvaStorage({
                    currentIndex: indice,
                });
            }
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(indice);
        };
        let storedIndex = null;
        if (props.store) {
            const datiStore = this.caricaStorage();
            if (datiStore) {
                storedIndex = datiStore.currentIndex;
            }
        }
        this.state = {
            index: storedIndex || props.initialIndex || props.index || 0,
            indexFromStore: !!storedIndex,
        };
        if (window.MutationObserver) {
            this.observer = new window.MutationObserver(this.aggiorna);
        }
    }
    componentDidMount() {
        // se l'index è stato impostato dallo store allora richiamo la callback onSelect
        const { indexFromStore, index } = this.state;
        const { onSelect } = this.props;
        if (indexFromStore && onSelect && index) {
            onSelect(index);
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { index } = this.props;
        deprecatedUsage(this, !nextProps.spaced, 'framework-ui-components.Tabs.spaced');
        if (nextProps.index !== index) {
            this.setState({ index: nextProps.index });
        }
    }
    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }
    render() {
        const { action, className, children, index, vertical, spaced, } = this.props;
        const { index: sIndex, } = this.state;
        if (this.refTabs != null && !this.listener && window.MutationObserver) {
            this.listener = true;
            this.observer.observe(this.refTabs, {
                attributes: true,
                childList: true,
                subtree: true,
            });
        }
        const classes = cns('tabs', {
            'tabs--vertical': vertical,
            'tabs--spaced': spaced,
        }, className);
        const actionClasses = cns('tabs__action', {
            'tabs__action--vertical': vertical,
        });
        const indexesClasses = cns('tabs__indexes', {
            'tabs__index--underlined': !vertical,
        });
        return (jsxs("div", { className: classes, children: [jsxs("div", { className: indexesClasses, ref: (r) => { this.refTabs = r; }, children: [React__default.Children.map(React__default.Children.toArray(children), (element, i) => {
                            const tab = element;
                            const tabClasses = cns('tabs__index', {
                                'tabs__index--selected': i === (index || sIndex),
                                'tabs__index--disabled': tab.props.disabled,
                            });
                            return (jsxs("div", { className: tabClasses, onClick: () => !tab.props.disabled && this.seleziona(i), role: "presentation", children: [jsxs("div", { className: "tab__title", children: [tab.props.title, tab.props.badge && jsx("div", { className: "tab__badge", children: tab.props.badge })] }), tab.props.action && jsx("div", { className: "tab__action", children: tab.props.action })] }, i));
                        }), action && (jsx("div", { className: actionClasses, children: action }))] }), React__default.Children.toArray(children)[(index || sIndex)]] }));
    }
}
Tabs.Tab = Tab;
Tabs.defaultProps = {
    action: null,
    children: null,
    className: '',
    index: null,
    initialIndex: 0,
    onSelect: null,
    vertical: false,
    store: null,
    spaced: false,
};

export { Tabs as default };
